const ACTION_KEY = 'REPORT_GENERATION_LOT';

const initialState = () => ({
  loading: false,
  completedRequest: null,
  incompletedRequest: null,
  errors: null
});

const reducer = (state = initialState(), action) => {
  switch (action.type) {
    case `${ACTION_KEY}_PENDING`: {
      return {
        ...state,
        loading: true
      };
    }
    case `${ACTION_KEY}_REJECTED`: {
      const { errors } = action.payload;

      const incompletedRequest = errors === undefined;

      return {
        ...state,
        errors,
        incompletedRequest,
        loading: false
      };
    }
    case `${ACTION_KEY}_FULFILLED`: {
      const completedRequest = action.payload;

      return {
        ...state,
        loading: false,
        errors: null,
        completedRequest
      };
    }

    case `${ACTION_KEY}_RESET`: {
      return initialState();
    }

    default:
      return state;
  }
};

export default reducer;
